import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { DiscountsAutocomplete, Form } from "@shared/components";

export const BannerListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("v1/banner_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="type"
          label={translate("v1/banner_admin.fields.type")}
          options={[
            { label: "Desconto", value: "discount" },
            { label: "Livro", value: "book" },
          ]}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <DiscountsAutocomplete
          name="discount"
          label={translate("v1/banner_admin.fields.discount")}
        />
      </Grid>
    </Grid>
  );
});
